/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Update_Timing_On_EditInputs */



/**
* | output |
* | --- |
* | "Update Timing On Edit" |
*
* @param {Options_Editor_Update_Timing_On_EditInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_update_timing_on_edit = /** @type {((inputs?: Options_Editor_Update_Timing_On_EditInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Update_Timing_On_EditInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour le minutage lors de l'édition")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisierungszeitpunkt beim Bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna i tempi di modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновление времени при редактировании")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar tiempo al editar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑更新时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集時の更新タイミング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादन पर समय अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar tempo na edição")
	return /** @type {LocalizedString} */ ("Update Timing On Edit")
});